define(
  'modules/animation',
  [
    'jquery',
    'velocity',
    'modules/utils'
  ],
  function (
    $,
    velocity,
    M_Utils
  ) {
    'use strict';

    var easings;
    var sequences = {
      disclaimer: {
        name: 'disclaimer',
        selectors: {
          disclaimer: '.js-anim-disclaimer'
        },
        elems: {},
        durations: {
          fadeIn: 500,
          fadeInDelay: 500
        }
      },
      screenIntro: {
        name: 'screenIntro',
        selectors: {
          loader1: '.js-anim-intro-loader-1',
          loader1Text: '.js-anim-intro-loader-1-text',
          loader1LoaderText: '.js-anim-intro-loader-1-loader-text',
          loader1Icon: '.js-anim-intro-loader-1-icon',
          loader2: '.js-anim-intro-loader-2',
          loader2Text: '.js-anim-intro-loader-2-text',
          loader2LoaderText: '.js-anim-intro-loader-2-loader-text',
          loader2Icon: '.js-anim-intro-loader-2-icon',
          loader3: '.js-anim-intro-loader-3',
          loader3Text: '.js-anim-intro-loader-3-text',
          loader3LoaderText: '.js-anim-intro-loader-3-loader-text',
          loader3Icon: '.js-anim-intro-loader-3-icon',
          loaderCircle: '.js-anim-intro-loader-circle',
          loaderBackgroundMedia: '.js-anim-intro-loader-media',
          loaderConfirmation: '.js-anim-intro-loader-4',
          loaderConfirmationHeading: '.js-anim-intro-loader-confirmation-heading',
          loaderConfirmationSubheading: '.js-anim-intro-loader-confirmation-subheading',
          loaderConfirmationButton: '.js-anim-intro-loader-confirmation-button',
          loaderConfirmationInstructions: '.js-anim-intro-loader-confirmation-instructions'
        },
        elems: {},
        durations: {
          loaderFadeIn: 500,
          loaderTextFadeIn: 1000,
          loaderDisplayTime: 1500,
          loaderFadeOut: 500,
          loaderCircleDuration: 11000,
          loaderCircleReverseDuration: 1000,
          loaderSequenceEnd: 500,
          loaderConfirmationFadeIn: 1000,
          loaderConfirmationFadeInDelay: 400,
          loaderBackgroundMedia: 1000,
          initialLoaderInnerDelay: 500,
          loaderConfirmationButtonScaleIn: 400,
          loader3IconFadeOut: 250,
          loader3IconFadeOutDelay: 800,
          loader3LoaderTextFadeOut: 250,
          loader3LoaderTextFadeOutDelay: 800
        }
      },
      screenIntroExit: {
        name: 'screenIntroExit',
        selectors: {
          screen: '.js-screen-intro'
        },
        elems: {},
        durations: {
          fadeOut: 500
        }
      },
      screenReveal: {
        name: 'screenReveal',
        selectors: {
          backgroundMedia: '.js-anim-reveal-media',
          reveal1: '.js-anim-reveal-1',
          reveal1Text: '.js-anim-reveal-1-text',
          reveal2: '.js-anim-reveal-2',
          reveal2Subheading: '.js-anim-reveal-2-subheading',
          reveal2Heading1: '.js-anim-reveal-2-heading-1',
          reveal2Heading2: '.js-anim-reveal-2-heading-2'
        },
        elems: {},
        durations: {
          screenFadeIn: 250,
          textFragFadeIn: 500,
          headingFadeInDelay: 900,
          heading2FadeInDelay: 3000,
          headingFadeIn: 1000,
          subheadingFadeInDelay: 5000,
          subheadingFadeIn: 1000,
          textScaleOut: 1000,
          textScaleOutDelay: 1250,
          reveal2FadeOut: 1000,
          reveal2FadeOutDelay: 1500
        }
      },
      screenRevealExit: {
        name: 'screenRevealExit',
        selectors: {
          screen: '.js-screen-reveal'
        },
        elems: {},
        durations: {
          fadeOut: 2000
        }
      },
      screenLoadingExteriorFeatures: {
        name: 'screenLoadingExteriorFeatures',
        selectors: {
          overlay: '.js-screen-loading-overlay',
          loader: '.js-anim-loading-exterior-features',
          subheading: '.js-anim-loading-exterior-features-subtitle'
        },
        elems: {},
        durations: {
          fade: 500,
          letterSpacing: 500
        }
      },
      screenLoadingInteriorFeatures: {
        name: 'screenLoadingInteriorFeatures',
        selectors: {
          overlay: '.js-screen-loading-overlay',
          loader: '.js-anim-loading-interior-features',
          subheading: '.js-anim-loading-interior-features-subtitle'
        },
        elems: {},
        durations: {
          fade: 500,
          letterSpacing: 500
        }
      },
      screenLoadingExteriorSpinA: {
        name: 'screenLoadingExteriorSpinA',
        selectors: {
          overlay: '.js-screen-loading-overlay',
          loader: '.js-anim-loading-exterior-spinA',
          subheading: '.js-anim-loading-exterior-spinA-subtitle'
        },
        elems: {},
        durations: {
          fade: 500,
          letterSpacing: 500
        }
      },
      screenLoadingInteriorSpinA: {
        name: 'screenLoadingInteriorSpinA',
        selectors: {
          overlay: '.js-screen-loading-overlay',
          loader: '.js-anim-loading-interior-spinA',
          subheading: '.js-anim-loading-interior-spinA-subtitle'
        },
        elems: {},
        durations: {
          fade: 500,
          letterSpacing: 500
        }
      },
      screenLoadingExteriorSpinB: {
        name: 'screenLoadingExteriorSpinB',
        selectors: {
          overlay: '.js-screen-loading-overlay',
          loader: '.js-anim-loading-exterior-spinB',
          subheading: '.js-anim-loading-exterior-spinB-subtitle'
        },
        elems: {},
        durations: {
          fade: 500,
          letterSpacing: 500
        }
      },
      screenLoadingInteriorSpinB: {
        name: 'screenLoadingInteriorSpinB',
        selectors: {
          overlay: '.js-screen-loading-overlay',
          loader: '.js-anim-loading-interior-spinB',
          subheading: '.js-anim-loading-interior-spinB-subtitle'
        },
        elems: {},
        durations: {
          fade: 500,
          letterSpacing: 500
        }
      },
      screenLoadingExit: {
        name: 'screenLoadingExit',
        selectors: {
          overlay: '.js-screen-loading-overlay',
          loader: '.js-anim-loading'
        },
        elems: {},
        durations: {
          fade: 500,
          minDisplayTime: 3000
        }
      },
      revealSpinContainer: {
        name: 'revealSpinContainer',
        selectors: {
          container: '.js-anim-spin-container'
        },
        elems: {},
        durations: {
          fade: 1000
        }
      },
      screenNavExterior: {
        name: 'screenNavExterior',
        selectors: {
          overlay: '.js-screen-nav-exterior-overlay',
          nav: '.js-nav-exterior',
          disclaimer: '.js-anim-nav-disclaimer'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      screenNavExteriorExit: {
        name: 'screenNavExteriorExit',
        selectors: {
          overlay: '.js-screen-nav-exterior-overlay',
          nav: '.js-nav-exterior',
          disclaimer: '.js-anim-nav-disclaimer'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      screenNavInterior: {
        name: 'screenNavInterior',
        selectors: {
          overlay: '.js-screen-nav-interior-overlay',
          nav: '.js-nav-interior',
          disclaimer: '.js-anim-nav-disclaimer'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      screenNavInteriorExit: {
        name: 'screenNavInteriorExit',
        selectors: {
          overlay: '.js-screen-nav-interior-overlay',
          nav: '.js-nav-interior',
          disclaimer: '.js-anim-nav-disclaimer'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      screenFeatureView: {
        name: 'screenFeatureView',
        selectors: {
          container: '.js-feature-container'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      screenFeatureViewExit: {
        name: 'screenFeatureViewExit',
        selectors: {
          container: '.js-feature-container',
          nav: '.js-anim-feature-nav'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      featureOpen: {
        name: 'featureOpen',
        selectors: {
          panel: '.js-anim-feature-panel',
          media: '.js-anim-feature-media'
        },
        elems: {},
        durations: {
          open: 500,
          openDelay: 0
        }
      },
      featureFadeIn: {
        name: 'featureFadeIn',
        selectors: {
          caption: '.js-anim-feature-caption',
          heading: '.js-anim-feature-heading',
          divider: '.js-anim-feature-divider',
          copy: '.js-anim-feature-copy',
          ctas: '.js-anim-feature-ctas',
          ctaMask: '.js-anim-feature-cta-mask',
          panel: '.js-anim-feature-panel',
          nav: '.js-anim-feature-nav'
        },
        elems: {},
        durations: {
          captionHeading: 400,
          divider: 300,
          copy: 250,
          ctas: 400,
          ctaMask: 900,
          nav: 400
        }
      },
      featureFadeOut: {
        name: 'featureFadeOut',
        selectors: {
          caption: '.js-anim-feature-caption',
          heading: '.js-anim-feature-heading',
          divider: '.js-anim-feature-divider',
          copy: '.js-anim-feature-copy',
          ctas: '.js-anim-feature-ctas',
          ctaMask: '.js-anim-feature-cta-mask',
          panel: '.js-anim-feature-panel',
          media: '.js-anim-feature-media',
          content: '.js-anim-feature-content'
        },
        elems: {},
        durations: {
          fade: 300
        }
      },
      featureMediaFadeIn: {
        name: 'featureMediaFadeIn',
        selectors: {
          media: '.js-anim-feature-media'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      featureMediaFadeOut: {
        name: 'featureMediaFadeOut',
        selectors: {
          media: '.js-anim-feature-media'
        },
        elems: {},
        durations: {
          fade: 500
        }
      },
      controlButtons: {
        name: 'controlButtons',
        selectors: {
          buttons: '.js-anim-control-button',
          icons: '.js-anim-control-icon',
          labels: '.js-anim-control-label'
        },
        elems: {},
        durations: {
          buttonOpacity: 100,
          buttonGrow: 1000,
          icons: 300,
          iconsAndLabelsDelay: 600,
          labels: 300
        }
      }
    };
    var state = {
      loadingScreenStartTime: Date.now()
    };
    var classes = {
      isActive: 'is--active',
      isAnimated: 'is--animated'
    };
    var selectors = {
      introPanel: '.js-screen-intro .c-nx-intro'
    };
    var numIntroLoaderIconFrames = 24;


    function init (config) {
      getElems();

      easings = config.easings;

      playSequence(sequences.disclaimer.name);
    }

    // Attempts to select elements, adding entry in 'elems', from each sequence for every selector in that sequence
    function getElems () {
      for (var seqName in sequences) {
        if (sequences.hasOwnProperty(seqName)) {

          var seq = sequences[seqName];

          for (var selectorName in seq.selectors) {
            if (seq.selectors.hasOwnProperty(selectorName)) {

              seq.elems[selectorName] = $(seq.selectors[selectorName]);
            }
          }
        }
      }
    }

    function playSequence (seqName, onComplete) {
      switch (seqName) {
        case sequences.disclaimer.name:
          playSequenceDisclaimer(onComplete);
          break;
        case sequences.screenIntro.name:
          playSequenceIntro(onComplete);
          break;
        case sequences.screenIntroExit.name:
          playSequenceIntroExit(onComplete);
          break;
        case sequences.screenReveal.name:
          playSequenceReveal(onComplete);
          break;
        case sequences.screenRevealExit.name:
          playSequenceRevealExit(onComplete);
          break;
        case sequences.screenLoadingExteriorFeatures.name:
          playSequenceLoading(onComplete, 'exteriorFeatures');
          break;
        case sequences.screenLoadingInteriorFeatures.name:
          playSequenceLoading(onComplete, 'interiorFeatures');
          break;
        case sequences.screenLoadingExteriorSpinA.name:
          playSequenceLoading(onComplete, 'exteriorSpinA');
          break;
        case sequences.screenLoadingInteriorSpinA.name:
          playSequenceLoading(onComplete, 'interiorSpinA');
          break;
        case sequences.screenLoadingExteriorSpinB.name:
          playSequenceLoading(onComplete, 'exteriorSpinB');
          break;
        case sequences.screenLoadingInteriorSpinB.name:
          playSequenceLoading(onComplete, 'interiorSpinB');
          break;
        case sequences.screenLoadingExit.name:
          playSequenceLoadingExit(onComplete);
          break;
        case sequences.revealSpinContainer.name:
          playSequenceRevealSpinContainer(onComplete);
          break;
        case sequences.screenNavExterior.name:
          playSequenceNavExterior(onComplete);
          break;
        case sequences.screenNavExteriorExit.name:
          playSequenceNavExteriorExit(onComplete);
          break;
        case sequences.screenNavInterior.name:
          playSequenceNavInterior(onComplete);
          break;
        case sequences.screenNavInteriorExit.name:
          playSequenceNavInteriorExit(onComplete);
          break;
        case sequences.screenFeatureView.name:
          playSequenceFeatureView(onComplete);
          break;
        case sequences.screenFeatureViewExit.name:
          playSequenceFeatureViewExit(onComplete);
          break;
        case sequences.featureOpen.name:
          playSequenceFeatureOpen(onComplete);
          break;
        case sequences.featureFadeIn.name:
          playSequenceFeatureFadeIn(onComplete);
          break;
        case sequences.featureFadeOut.name:
          playSequenceFeatureFadeOut(onComplete);
          break;
        case sequences.featureMediaFadeIn.name:
          playSequenceFeatureMediaFadeIn(onComplete);
          break;
        case sequences.featureMediaFadeOut.name:
          playSequenceFeatureMediaFadeOut(onComplete);
          break;
        case sequences.controlButtons.name:
          playSequenceControlButtons(onComplete);
          break;
        default:
          break;
      }
    }

    function resetSequence (seqName) {
      switch (seqName) {
        case sequences.featureOpen.name:
          resetSequenceFeatureOpen();
          break;
        default:
          break;
      }
    }

    function playSequenceDisclaimer () {
      $.Velocity.animate(sequences.disclaimer.elems.disclaimer, {
        opacity: 1
      }, {
        delay: sequences.disclaimer.durations.fadeInDelay,
        duration: sequences.disclaimer.durations.fadeIn,
        easing: easings.smooth
      });
    }

    function playSequenceIntro (onComplete) {

      // Define intro steps and events to trigger them
      var eventRequirementsState = {
        'introMediaEnabled': {
          animComplete: false
        },
        'intro1Start': {
          animComplete: false
        },
        'intro2Start': {
          animComplete: false
        },
        'intro3Start': {
          animComplete: false
        },
        'intro3Complete': {
          animComplete: false
        }
      };

      $.Velocity.animate(sequences.screenIntro.elems.loaderCircle, {
        strokeDashoffset: ['109px', '360px']
      }, {
        duration: sequences.screenIntro.durations.loaderCircleDuration,
        easing: easings.linear
      });

      M_Utils.handleListenerWithRequirements('nx-animevent-intro1initalised', eventRequirementsState.intro1Start, function () {
        // Start the velocity Chain
        M_Utils.triggerEvent('nx-mediaevent-intro1initalised', {animComplete: true});

        $(selectors.introPanel).removeClass(classes.isActive);
        sequences.screenIntro.elems.loader1.addClass(classes.isActive);
        sequences.screenIntro.elems.loader1.css({opacity: 1});

        $.Velocity.animate(sequences.screenIntro.elems.loader1Icon, {
          backgroundPositionY: '100%',
          backgroundPositionX: '0%'
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          delay: sequences.screenIntro.durations.initialLoaderInnerDelay,
          easing: [numIntroLoaderIconFrames]
        });

        $.Velocity.animate(sequences.screenIntro.elems.loader1Icon, {
          opacity: 1
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          easing: easings.decelerate
        });

        $.Velocity.animate(sequences.screenIntro.elems.loader1LoaderText, {
          opacity: 1,
          translateY: ['0px', '10px']
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          delay: sequences.screenIntro.durations.initialLoaderInnerDelay,
          easing: easings.decelerate
        })
        .then(function () {
          return $.Velocity.animate(sequences.screenIntro.elems.loader1Text, {
            opacity: 1,
            translateY: ['0px', '40px']
          }, {
            duration: sequences.screenIntro.durations.loaderTextFadeIn,
            easing: easings.decelerate
          });
        })
        .then(function () {
          $.Velocity.animate(sequences.screenIntro.elems.loader1Icon, {
            opacity: 0
          }, {
            delay: sequences.screenIntro.durations.loaderDisplayTime,
            duration: sequences.screenIntro.durations.loaderFadeOut,
            easing: easings.decelerate
          });

          $.Velocity.animate(sequences.screenIntro.elems.loader1LoaderText, {
            opacity: 0
          }, {
            delay: sequences.screenIntro.durations.loaderDisplayTime,
            duration: sequences.screenIntro.durations.loaderFadeOut,
            easing: easings.decelerate
          });

          return $.Velocity.animate(sequences.screenIntro.elems.loader1Text, {
            opacity: 0
          }, {
            delay: sequences.screenIntro.durations.loaderDisplayTime,
            duration: sequences.screenIntro.durations.loaderFadeOut,
            easing: easings.decelerate
          });
        })
        .then(function () {
          M_Utils.triggerEvent('nx-animevent-intro1complete', {animComplete: true});
        });
      });

      M_Utils.handleListenerWithRequirements('nx-mediaevent-intro1initalised', eventRequirementsState.introMediaEnabled, function () {
        $.Velocity.animate(sequences.screenIntro.elems.loaderBackgroundMedia, {
          opacity: 1
        }, {
          duration: sequences.screenIntro.durations.loaderBackgroundMedia,
          easing: easings.decelerate,
          delay: 0
        });
      });

      M_Utils.handleListenerWithRequirements('nx-animevent-intro1complete', eventRequirementsState.intro2Start, function () {
        sequences.screenIntro.elems.loader1.css({opacity: 0});
        $(selectors.introPanel).removeClass(classes.isActive);
        sequences.screenIntro.elems.loader2.addClass(classes.isActive);
        sequences.screenIntro.elems.loader2.css({opacity: 1});

        $.Velocity.animate(sequences.screenIntro.elems.loader2Icon, {
          backgroundPositionY: '100%',
          backgroundPositionX: '0%'
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          easing: [numIntroLoaderIconFrames]
        });

        $.Velocity.animate(sequences.screenIntro.elems.loader2Icon, {
          opacity: 1
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          easing: easings.decelerate
        });

        $.Velocity.animate(sequences.screenIntro.elems.loader2LoaderText, {
          opacity: 1,
          translateY: ['0px', '10px']
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          easing: easings.decelerate
        })
        .then(function () {
          return $.Velocity.animate(sequences.screenIntro.elems.loader2Text, {
            opacity: 1,
            translateY: ['0px', '40px']
          }, {
            duration: sequences.screenIntro.durations.loaderTextFadeIn,
            easing: easings.decelerate
          });
        })
        .then(function () {
          $.Velocity.animate(sequences.screenIntro.elems.loader2Icon, {
            opacity: 0
          }, {
            delay: sequences.screenIntro.durations.loaderDisplayTime,
            duration: sequences.screenIntro.durations.loaderFadeOut,
            easing: easings.decelerate
          });

          $.Velocity.animate(sequences.screenIntro.elems.loader2LoaderText, {
            opacity: 0
          }, {
            delay: sequences.screenIntro.durations.loaderDisplayTime,
            duration: sequences.screenIntro.durations.loaderFadeOut,
            easing: easings.decelerate
          });

          return $.Velocity.animate(sequences.screenIntro.elems.loader2Text, {
            opacity: 0
          }, {
            delay: sequences.screenIntro.durations.loaderDisplayTime,
            duration: sequences.screenIntro.durations.loaderFadeOut,
            easing: easings.decelerate
          });
        })
        .then(function () {
          M_Utils.triggerEvent('nx-animevent-intro2complete', {animComplete: true});
        });
      });

      M_Utils.handleListenerWithRequirements('nx-animevent-intro2complete', eventRequirementsState.intro3Start, function () {
        sequences.screenIntro.elems.loader2.css({opacity: 0});
        $(selectors.introPanel).removeClass(classes.isActive);
        sequences.screenIntro.elems.loader3.addClass(classes.isActive);
        sequences.screenIntro.elems.loader3.css({opacity: 1});

        $.Velocity.animate(sequences.screenIntro.elems.loader3Icon, {
          backgroundPositionY: '100%',
          backgroundPositionX: '0%'
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          easing: [numIntroLoaderIconFrames]
        });

        $.Velocity.animate(sequences.screenIntro.elems.loader3Icon, {
          opacity: 1
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          easing: easings.decelerate
        });

        $.Velocity.animate(sequences.screenIntro.elems.loader3LoaderText, {
          opacity: 1,
          translateY: ['0px', '10px']
        }, {
          duration: sequences.screenIntro.durations.loaderFadeIn,
          easing: easings.decelerate
        })
        .then(function () {
          return $.Velocity.animate(sequences.screenIntro.elems.loader3Text, {
            opacity: 1,
            translateY: ['0px', '40px']
          }, {
            duration: sequences.screenIntro.durations.loaderTextFadeIn,
            easing: easings.decelerate
          });
        })
        .then(function () {
          return $.Velocity.animate(sequences.screenIntro.elems.loader3Text, {
            opacity: 0
          }, {
            delay: sequences.screenIntro.durations.loaderDisplayTime,
            duration: sequences.screenIntro.durations.loaderFadeOut,
            easing: easings.decelerate
          });
        })
        .then(function () {
          M_Utils.triggerEvent('nx-animevent-intro3complete', {animComplete: true});
        });
      });

      M_Utils.handleListenerWithRequirements(['nx-animevent-intro3complete'], eventRequirementsState.intro3Complete, function () {
        sequences.screenIntro.elems.loaderConfirmation.addClass(classes.isActive);

        $.Velocity.animate(sequences.screenIntro.elems.loaderConfirmationButton, {
          opacity: 0,
          scale: 0.1
        }, {
          duration: 1,
          easing: easings.linear
        })
        .then(function () {
          $.Velocity.animate(sequences.screenIntro.elems.loader3Icon, {
            opacity: 0
          }, {
            duration: sequences.screenIntro.durations.loader3IconFadeOut,
            delay: sequences.screenIntro.durations.loader3IconFadeOutDelay,
            easing: easings.decelerate
          });

          $.Velocity.animate(sequences.screenIntro.elems.loader3LoaderText, {
            opacity: 0
          }, {
            duration: sequences.screenIntro.durations.loader3LoaderTextFadeOut,
            delay: sequences.screenIntro.durations.loader3LoaderTextFadeOutDelay,
            easing: easings.decelerate
          });

          return $.Velocity.animate(sequences.screenIntro.elems.loaderConfirmation, {
            opacity: 1
          }, {
            duration: sequences.screenIntro.durations.loaderTextFadeIn,
            easing: easings.decelerate
          });
        })
        .then(function () {
          sequences.screenIntro.elems.loaderConfirmationButton.addClass(classes.isAnimated);

          $.Velocity.animate(sequences.screenIntro.elems.loaderConfirmationButton, {
            opacity: 1,
            scale: 1.0
          }, {
            duration: sequences.screenIntro.durations.loaderConfirmationButtonScaleIn,
            easing: easings.decelerate
          });

          $.Velocity.animate(sequences.screenIntro.elems.loaderConfirmationHeading, {
            opacity: 1,
            letterSpacing: ['0.375rem', '3.125rem']
          }, {
            duration: sequences.screenIntro.durations.loaderConfirmationFadeIn,
            delay: sequences.screenIntro.durations.loaderConfirmationFadeInDelay,
            easing: easings.decelerate
          });

          $.Velocity.animate(sequences.screenIntro.elems.loaderConfirmationSubheading, {
            opacity: 1
          }, {
            duration: sequences.screenIntro.durations.loaderConfirmationFadeIn,
            delay: sequences.screenIntro.durations.loaderConfirmationFadeInDelay,
            easing: easings.decelerate
          });

          return $.Velocity.animate(sequences.screenIntro.elems.loaderConfirmationInstructions, {
            opacity: 1,
            translateY: ['0px', '40px']
          }, {
            duration: sequences.screenIntro.durations.loaderConfirmationFadeIn,
            delay: sequences.screenIntro.durations.loaderConfirmationFadeInDelay,
            easing: easings.decelerate
          });
        })
        .then(function () {
          sequences.screenIntro.elems.loaderConfirmationButton.css({'transform': ''});

          return $.Velocity.animate(sequences.screenIntro.elems.loader3, {
            opacity: 0
          }, {
            duration: sequences.screenIntro.durations.loaderSequenceEnd,
            easing: easings.decelerate
          });
        })

        // complete
        .then(function () {
          if (typeof onComplete === 'function') {
            onComplete();
          }
        });
      });

      // Start the velocity Chain
      M_Utils.triggerEvent('nx-animevent-intro1initalised', {animComplete: true});
    }

    function playSequenceIntroExit (onComplete) {
      $(selectors.introPanel).removeClass(classes.isActive);

      $.Velocity.animate(sequences.screenIntroExit.elems.screen, {
        opacity: 0
      }, {
        duration: sequences.screenIntroExit.durations.fadeOut,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceReveal (onComplete) {
      var $reveal1TextFrags = sequences.screenReveal.elems.reveal1Text.find(sequences.screenReveal.selectors.reveal1Text + '-fragment');

      $.Velocity.animate(sequences.screenReveal.elems.reveal1, {
        opacity: 1
      }, {
        duration: sequences.screenReveal.durations.screenFadeIn,
        easing: easings.decelerate
      })
      .then(function () {
        sequences.screenReveal.elems.reveal1Text.css({opacity: 1});

        // fade in each fragment (word) in the reveal text
        for (var f = 0; f < $reveal1TextFrags.length; f++) {
          var res = $.Velocity.animate($reveal1TextFrags[f], {
            opacity: 1
          }, {
            duration: sequences.screenReveal.durations.textFragFadeIn,
            easing: easings.decelerate,
            delay: sequences.screenReveal.durations.textFragFadeIn + (f * sequences.screenReveal.durations.textFragFadeIn)
          });

          if (f === $reveal1TextFrags.length - 1) {
            return res;
          }
        }
      })
      .then(function () {
        return $.Velocity.animate(sequences.screenReveal.elems.reveal1, {
          scale: 1.5,
          opacity: 0
        }, {
          duration: sequences.screenReveal.durations.textScaleOut,
          easing: easings.decelerate,
          delay: sequences.screenReveal.durations.textScaleOutDelay
        });
      })
      .then(function () {
        return $.Velocity.animate(sequences.screenReveal.elems.reveal2Subheading, {
          opacity: 1,
          translateY: ['40px', '80px']
        }, {
          delay: sequences.screenReveal.durations.subheadingFadeInDelay,
          duration: sequences.screenReveal.durations.subheadingFadeIn,
          easing: easings.decelerate
        });
      })
      .then(function () {
        var heading2width = sequences.screenReveal.elems.reveal2Heading2.outerWidth();

        sequences.screenReveal.elems.reveal2Heading2.css({'width': '0px'});

        $.Velocity.animate(sequences.screenReveal.elems.reveal2Heading1, {
          opacity: 1,
          translateY: ['0px', '40px']
        }, {
          duration: sequences.screenReveal.durations.headingFadeIn,
          easing: easings.decelerate,
          delay: sequences.screenReveal.durations.headingFadeInDelay
        });

        $.Velocity.animate(sequences.screenReveal.elems.reveal2Subheading, {
          translateY: ['0px', '40px']
        }, {
          duration: sequences.screenReveal.durations.headingFadeIn,
          easing: easings.decelerate,
          delay: sequences.screenReveal.durations.headingFadeInDelay
        });

        return $.Velocity.animate(sequences.screenReveal.elems.reveal2Heading2, {
          opacity: 1,
          width: heading2width
        }, {
          duration: sequences.screenReveal.durations.headingFadeIn,
          easing: easings.decelerate,
          delay: sequences.screenReveal.durations.heading2FadeInDelay
        });
      })
      .then(function () {
        return $.Velocity.animate(sequences.screenReveal.elems.reveal2, {
          opacity: 0
        }, {
          duration: sequences.screenReveal.durations.reveal2FadeOut,
          easing: easings.decelerate,
          delay: sequences.screenReveal.durations.reveal2FadeOutDelay
        });
      })

      // complete
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceRevealExit (onComplete) {
      sequences.revealSpinContainer.elems.container.css({ 'opacity': '0' });

      $.Velocity.animate(sequences.screenRevealExit.elems.screen, {
        opacity: 0
      }, {
        duration: sequences.screenIntroExit.durations.fadeOut,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceLoading (onComplete, loadingScreenType) {
      var sequenceName = 'screenLoading' + M_Utils.capitalizeFirstLetter(loadingScreenType);

      state.loadingScreenStartTime = Date.now();

      $.Velocity.animate(sequences[sequenceName].elems.overlay, {
        opacity: 1
      }, {
        duration: sequences[sequenceName].durations.fade,
        easing: easings.decelerate
      });

      $.Velocity.animate(sequences[sequenceName].elems.subheading, {
        letterSpacing: ['0.375rem', '3.125rem']
      }, {
        duration: sequences[sequenceName].durations.letterSpacing,
        easing: easings.decelerate
      });

      $.Velocity.animate(sequences[sequenceName].elems.loader, {
        opacity: 1
      }, {
        duration: sequences[sequenceName].durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceLoadingExit (onComplete) {
      var exitDelay = 0;
      var timeSinceLoadingStart = Date.now() - state.loadingScreenStartTime;

      if (timeSinceLoadingStart < sequences.screenLoadingExit.durations.minDisplayTime) {
        exitDelay = sequences.screenLoadingExit.durations.minDisplayTime - timeSinceLoadingStart;
      }

      $.Velocity.animate(sequences.screenLoadingExit.elems.overlay, {
        opacity: 0
      }, {
        delay: exitDelay,
        duration: sequences.screenLoadingExit.durations.fade,
        easing: easings.decelerate
      });

      $.Velocity.animate(sequences.screenLoadingExit.elems.loader, {
        opacity: 0
      }, {
        delay: exitDelay,
        duration: sequences.screenLoadingExit.durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceRevealSpinContainer (onComplete) {
      $.Velocity.animate(sequences.revealSpinContainer.elems.container, {
        opacity: 1
      }, {
        duration: sequences.revealSpinContainer.durations.fade,
        easing: easings.decelerate,
        progress: function (elements, complete, remaining, start, tweenValue) {
          M_Utils.triggerEvent( 'AUDIOSETFADE', { fade: complete });
        }
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceNavExterior (onComplete) {
      var elems = sequences.screenNavExterior.elems.overlay
        .add(sequences.screenNavExterior.elems.nav)
        .add(sequences.screenNavExterior.elems.disclaimer);

      $.Velocity.animate(elems, {
        opacity: 1
      }, {
        duration: sequences.screenNavExterior.durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceNavExteriorExit (onComplete) {
      var elems = sequences.screenNavExteriorExit.elems.overlay
        .add(sequences.screenNavExteriorExit.elems.nav)
        .add(sequences.screenNavExteriorExit.elems.disclaimer);

      $.Velocity.animate(elems, {
        opacity: 0
      }, {
        duration: sequences.screenNavExteriorExit.durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceNavInterior (onComplete) {
      var elems = sequences.screenNavInterior.elems.overlay
        .add(sequences.screenNavInterior.elems.nav)
        .add(sequences.screenNavInterior.elems.disclaimer);

      $.Velocity.animate(elems, {
        opacity: 1
      }, {
        duration: sequences.screenNavInterior.durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceNavInteriorExit (onComplete) {
      var elems = sequences.screenNavInteriorExit.elems.overlay
        .add(sequences.screenNavInteriorExit.elems.nav)
        .add(sequences.screenNavInteriorExit.elems.disclaimer);

      $.Velocity.animate(elems, {
        opacity: 0
      }, {
        duration: sequences.screenNavInteriorExit.durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceFeatureView (onComplete) {
      $.Velocity.animate(sequences.screenFeatureView.elems.container, {
        opacity: 1
      }, {
        duration: sequences.screenFeatureView.durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceFeatureViewExit (onComplete) {
      sequences.screenFeatureViewExit.elems.nav.css({ 'opacity': '0' });

      $.Velocity.animate(sequences.screenFeatureViewExit.elems.container, {
        opacity: 0
      }, {
        duration: sequences.screenFeatureViewExit.durations.fade,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceFeatureOpen (onComplete) {
      var useMobileLayout = (M_Utils.getIsMobile() || M_Utils.getIsTouchDevice()) && M_Utils.getIsPortrait();

      var animPropsMedia = useMobileLayout ? {
        height: '75vw'
      }
      : {
        right: sequences.featureOpen.elems.panel.outerWidth() + 'px'
      };
      var animPropsPanel = useMobileLayout ? {
        opacity: 1,
        translateY: [ '0vh', '10vh' ]
      }
      : {
        opacity: 1,
        translateX: [ '0%', '100%' ]
      };

      $.Velocity.animate(sequences.featureOpen.elems.media,
      animPropsMedia,
      {
        duration: sequences.featureOpen.durations.open,
        delay: sequences.featureOpen.durations.openDelay,
        easing: easings.decelerate
      });

      $.Velocity.animate(sequences.featureOpen.elems.panel,
      animPropsPanel,
      {
        duration: sequences.featureOpen.durations.open,
        delay: sequences.featureOpen.durations.openDelay,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceFeatureFadeIn (onComplete) {
      sequences.featureFadeIn.elems.panel.css({ 'opacity': '1' });

      $.Velocity.animate(sequences.featureFadeIn.elems.nav, {
        opacity: 1
      }, {
        duration: sequences.featureFadeIn.durations.nav,
        easing: easings.decelerate
      });

      $.Velocity.animate(sequences.featureFadeIn.elems.caption.add(sequences.featureFadeIn.elems.heading), {
        translateX: [ '0px', '-30px' ],
        opacity: 1
      }, {
        duration: sequences.featureFadeIn.durations.captionHeading,
        easing: easings.decelerate
      })
      .then(function () {
        return $.Velocity.animate(sequences.featureFadeIn.elems.divider, {
          height: [ sequences.featureFadeIn.elems.divider.outerHeight() + 'px', '0px' ],
          opacity: 1
        }, {
          duration: sequences.featureFadeIn.durations.divider,
          easing: easings.decelerate
        });
      })
      .then(function () {
        return $.Velocity.animate(sequences.featureFadeIn.elems.copy, {
          translateX: [ '0px', '-30px' ],
          opacity: 1
        }, {
          duration: sequences.featureFadeIn.durations.copy,
          easing: easings.decelerate
        });
      })
      .then(function () {
        $.Velocity.animate(sequences.featureFadeIn.elems.ctas, {
          opacity: 1
        }, {
          duration: sequences.featureFadeIn.durations.ctas,
          easing: easings.decelerate
        });

        return $.Velocity.animate(sequences.featureFadeIn.elems.ctaMask, {
          translateX: [ '100%', '0%' ]
        }, {
          duration: sequences.featureFadeIn.durations.ctaMask,
          easing: easings.decelerate
        });
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceFeatureFadeOut (onComplete) {
      var elems = sequences.featureFadeOut.elems.caption
          .add(sequences.featureFadeOut.elems.heading)
          .add(sequences.featureFadeOut.elems.divider)
          .add(sequences.featureFadeOut.elems.copy)
          .add(sequences.featureFadeOut.elems.ctas);

      $.Velocity.animate(elems, {
        opacity: 0
      }, {
        duration: sequences.featureFadeOut.durations.content,
        easing: easings.decelerate
      })
      .then(function () {
        sequences.featureFadeOut.elems.ctaMask.css({ 'transform': 'translateX(0px)' });
        sequences.featureFadeOut.elems.panel.css({ 'opacity': '0' });
        sequences.featureFadeOut.elems.content.scrollTop(0);

        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function resetSequenceFeatureOpen () {
      var useMobileLayout = (M_Utils.getIsMobile() || M_Utils.getIsTouchDevice()) && M_Utils.getIsPortrait();

      sequences.featureOpen.elems.media.css(
        useMobileLayout ?
        {
          height: '100vw',
          right: '0'
        }
        : {
          height: 'auto',
          right: '0'
        }
      );
      sequences.featureOpen.elems.panel.css(
        useMobileLayout ?
        {
          transform: 'translateX(0%) translateY(10vh)',
          opacity: 0
        }
        : {
          transform: 'translateX(100%) translateY(0vh)',
          opacity: 0
        }
      );

      sequences.featureFadeOut.elems.ctaMask.css({ 'transform': 'translateX(0px)' });
      sequences.featureFadeOut.elems.panel.css({ 'opacity': '0' });
      sequences.featureFadeOut.elems.content.scrollTop(0);
    }

    function playSequenceFeatureMediaFadeIn (onComplete) {
      $.Velocity.animate(sequences.featureMediaFadeIn.elems.media, {
        opacity: 1
      }, {
        duration: sequences.featureMediaFadeIn.durations.fade,
        easing: easings.linear
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceFeatureMediaFadeOut (onComplete) {
      $.Velocity.animate(sequences.featureMediaFadeIn.elems.media, {
        opacity: 0
      }, {
        duration: sequences.featureMediaFadeIn.durations.fade,
        easing: easings.linear
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    function playSequenceControlButtons (onComplete) {
      sequences.controlButtons.elems.buttons.css({ 'opacity': '1' });

      $.Velocity.animate(sequences.controlButtons.elems.buttons, {
        scale: [ 1.0, 0 ]
      }, {
        duration: sequences.controlButtons.durations.buttonGrow,
        easing: easings.decelerate
      });

      $.Velocity.animate(sequences.controlButtons.elems.icons, {
        opacity: 1
      }, {
        duration: sequences.controlButtons.durations.icons,
        delay: sequences.controlButtons.durations.iconsAndLabelsDelay,
        easing: easings.decelerate
      });

      $.Velocity.animate(sequences.controlButtons.elems.labels, {
        opacity: 1,
        translateY: ['0px', '20px']
      }, {
        duration: sequences.controlButtons.durations.labels,
        delay: sequences.controlButtons.durations.iconsAndLabelsDelay,
        easing: easings.decelerate
      })
      .then(function () {
        if (typeof onComplete === 'function') {
          onComplete();
        }
      });
    }

    return {
      init: init,
      playSequence: playSequence,
      resetSequence: resetSequence
    }
});

